import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './MobileDevelopment.css';

const MobileDevelopment = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="mobile-development-page-wrapper">
      <div className="mobile-development-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'Mobile Development')}
        />

        <div className="mobile-development-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="mobile-development-page-hero">
          <h1>Mobile Development Services</h1>
          <p>
            BlackRoth delivers high-quality Mobile Application Development
            services that create secure, scalable, and user-friendly mobile
            solutions aligned with business objectives.
          </p>
        </div>

        <section className="mobile-development-page-section">
          <h2>Overview</h2>
          <p>
            Mobile applications are critical touchpoints for modern businesses.
            BlackRoth designs and develops mobile apps that offer seamless
            performance, intuitive user experiences, and long-term scalability
            across platforms.
          </p>
        </section>

        <section className="mobile-development-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our mobile development solutions combine modern frameworks,
            performance optimization, and secure architectures to deliver
            reliable applications for diverse business needs.
          </p>
        </section>

        <section className="mobile-development-page-section">
          <h2>Services We Offer</h2>
          <ul className="mobile-development-service-list">
            <li>iOS & Android App Development</li>
            <li>Cross-Platform App Development</li>
            <li>Custom Mobile App Solutions</li>
            <li>UI/UX Design for Mobile Applications</li>
            <li>Mobile App Modernization</li>
            <li>API Integration & Backend Connectivity</li>
            <li>App Testing & Quality Assurance</li>
            <li>App Deployment & Maintenance</li>
          </ul>
        </section>

        <section className="mobile-development-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            BlackRoth's Mobile Development services support industries such as
            fintech, healthcare, e-commerce, logistics, education, and
            enterprise mobility by delivering impactful mobile solutions.
          </p>
        </section>

        <section className="mobile-development-page-section">
          <h2>Technology Stack</h2>
          <p>
            We work with modern mobile technologies including React Native,
            Flutter, Swift, Kotlin, secure APIs, cloud backends, and scalable
            mobile architectures.
          </p>
        </section>

        <section className="mobile-development-page-section">
          <h2>Quality & Performance</h2>
          <p>
            BlackRoth ensures high performance, security, and reliability
            through rigorous testing, performance optimization, and adherence
            to platform best practices.
          </p>
        </section>
      </div>
    </div>
  );
};

export default MobileDevelopment;

